@if (loanService.application()?.property) {
  <h3 class="title">Bostaden</h3>

  @if (propertiesWithDoubleKalpAndApprovedWithoutOldProperty.includes(loanService.application()?.oldProperty?.futurePropertyOwnership!)) {
    <p>
      Observera att KALP för den nya bostaden baseras på ett lån utifrån 'tänkt
      pris' istället för 'lånebelopp'
    </p>
  }

  <div class="group-holder">
    <div class="subgroup-holder">
      <spb-kalp-item
        [textValue]="true"
        text="Typ"
        [value]="(loanService.application()?.property?.type ?? 0) | propertyType"/>
      <spb-kalp-item
        format="1.0-0"
        text="Tänkt pris"
        [value]="loanService.application()?.property?.price"/>
      <spb-kalp-item
        format="1.0-0"
        text="Lånebelopp"
        [value]="loanService.application()?.property?.loanAmount"/>
      <spb-kalp-item
        format="1.0-0"
        text="Kontantinsats"
        [value]="loanService.application()?.property?.downPayment"/>
      <spb-kalp-item
        format="1.0-0"
        suffix="%"
        text="Kontantinsats (%)"
        [value]="(loanService.application()?.property?.downPayment ?? 0) / (loanService.application()?.property?.price ?? 1) * 100"/>
      @if (loanService.application()?.property?.type === 2) {
        <spb-kalp-item
          format="1.0-0"
          text="Avgift"
          [value]="loanService.application()?.property?.fee"/>
      }
      @if (loanService.application()?.property?.type !== 2) {
        <spb-kalp-item
          format="1.0-0"
          text="Fastighetsskatt (kr/mån)"
          [value]="loanService.application()?.property?.propertyTax"/>
      }
      <spb-kalp-item
        format="1.0-0"
        text="Drift"
        [value]="loanService.application()?.property?.runCost"/>
      <spb-kalp-item
        format="1.2-2"
        text="Ränta"
        [value]="loanService.application()?.property?.interestPercent! * 100"
        suffix="%"/>
      <spb-kalp-item
        format="1.0-0"
        text="Ränta (kr/mån)"
        [value]="loanService.application()?.property?.interestSumMonth"/>
      <spb-kalp-item
        format="1.0-0"
        text="Amortering (kr/mån)"
        [value]="loanService.application()?.property?.mortgage"/>
      <spb-kalp-item
        format="1.0-0"
        text="Amortering (%)"
        [value]="loanService.application()?.property?.mortgagePercent! * 100"/>
    </div>
  </div>
}